export default function Contact() {
  return (
    <section
      id="contact"
      className="py-20 px-6 bg-white text-gray-800 scroll-mt-24"
      data-aos="fade-up"
    >
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-4 transition-colors duration-300 hover:text-green-700">
          Get in Touch
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          I’d love to hear from you! Whether it's about research collaboration, technical projects, or opportunities to innovate in the field of information science—feel free to reach out.
        </p>

        <form
          action="https://formspree.io/f/mzzeqwvg"
          method="POST"
          className="space-y-6"
        >
          <div>
            <label htmlFor="name" className="block text-left font-medium mb-1">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              required
              className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Your Name"
            />
          </div>

          <div>
            <label htmlFor="email" className="block text-left font-medium mb-1">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              required
              className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-left font-medium mb-1">Message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              required
              className="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="Your message..."
            ></textarea>
          </div>

          <button
            type="submit"
            className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition duration-200"
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
}
